import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=6c20d3c1&scoped=true"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"
import style0 from "./change-password.vue?vue&type=style&index=0&id=6c20d3c1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c20d3c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c20d3c1')) {
      api.createRecord('6c20d3c1', component.options)
    } else {
      api.reload('6c20d3c1', component.options)
    }
    module.hot.accept("./change-password.vue?vue&type=template&id=6c20d3c1&scoped=true", function () {
      api.rerender('6c20d3c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/componentsTeacher/detail-pane/change-password.vue"
export default component.exports